"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "frascati": {
    "317f1f61": [{
      "hkey": "bb7cc010",
      "slug": "frascati",
      "name": "Frascati",
      "primary": true,
      "skipSearch": false
    }],
    "cocciano": [{
      "hkey": "bb7cc010",
      "slug": "frascati",
      "name": "Frascati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "97764e77": [{
      "hkey": "bb7cc010",
      "slug": "frascati",
      "name": "Frascati",
      "primary": true,
      "skipSearch": false
    }],
    "vermicino": [{
      "hkey": "bb7cc010",
      "slug": "frascati",
      "name": "Frascati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;